import { EditableField } from '../Models'

export const FIELD_LIMITS = {
  prefix: 3,
  number: 12,
  suffix: 4,
  description: 120,
} as const satisfies Record<EditableField, number>

export const FIELD_ORDER: readonly EditableField[] = ['prefix', 'number', 'suffix', 'description']
